import * as yup from 'yup';

export const choose_applicanttype_schema = {
  applicantType: '',
  number: '',
};

export const choose_applicanttype_validatiom_schema = yup.object().shape({
  number: yup
    .string()
    .required('number_required')
    .matches(/^[0-9]+$/, 'number_validation')
    .when('applicantType', {
      is: applicantType =>
        applicantType?.id?.toString() === '11' || applicantType?.id?.toString() === '12',
      then: schema => schema.min(10, 'number_min_10_validation'),
      otherwise: schema => schema.min(6, 'number_min_6_validation'),
    }),
});
